module.exports = __webpack_public_path__ + "static/media/logo.909b9cd7.svg";